// All sizes in mm (fonts in pt). A4 sheets: 210 × 297.
export const LAYOUTS = {
  a4_24: { kind: "a4", label: "24 per sheet", size: "70 × 37 mm", w: 70, h: 37, cols: 3, rows: 8, top: 0.5, left: 0, gapX: 0, gapY: 0, pad: 3, name: 9, price: 12, digits: 7, meta: 6, bcMax: 46, bcMinH: 8 },
  a4_40: { kind: "a4", label: "40 per sheet", size: "52.5 × 29.7 mm", w: 52.5, h: 29.7, cols: 4, rows: 10, top: 0, left: 0, gapX: 0, gapY: 0, pad: 2.2, name: 7.5, price: 10, digits: 6, meta: 5, bcMax: 40, bcMinH: 6 },
  a4_65: { kind: "a4", label: "65 per sheet", size: "38.1 × 21.2 mm", w: 38.1, h: 21.2, cols: 5, rows: 13, top: 10.7, left: 4.75, gapX: 2.5, gapY: 0, pad: 1.3, name: 5.5, price: 7.5, digits: 5, meta: 4.5, bcMax: 35.5, bcMinH: 4 },
  th_50x25: { kind: "thermal", label: "50 × 25 mm", size: "label roll", w: 50, h: 25, pad: 1.6, name: 7, price: 9.5, digits: 6, meta: 5, bcMax: 40, bcMinH: 5 },
  th_38x25: { kind: "thermal", label: "38 × 25 mm", size: "label roll", w: 38, h: 25, pad: 1.4, name: 6, price: 8.5, digits: 5.5, meta: 4.5, bcMax: 35, bcMinH: 5 },
  th_40x30: { kind: "thermal", label: "40 × 30 mm", size: "label roll", w: 40, h: 30, pad: 1.6, name: 7, price: 10, digits: 6, meta: 5, bcMax: 36, bcMinH: 6 },
};

export const perPage = (L) => (L.kind === "a4" ? L.cols * L.rows : 1);
export const pageSize = (L) => (L.kind === "a4" ? "210mm 297mm" : `${L.w}mm ${L.h}mm`);
export const MM = 3.7795;

export function slotPos(L, i) {
  const c = i % L.cols, r = Math.floor(i / L.cols);
  return { left: `${L.left + c * (L.w + L.gapX)}mm`, top: `${L.top + r * (L.h + L.gapY)}mm` };
}

// Splits tags into pages; A4 pages start with (start-1) blank slots.
export function paginate(L, items, start) {
  if (L.kind !== "a4") return items.map((t) => [t]);
  const slots = [...Array(Math.max(0, start - 1)).fill(null), ...items];
  const n = perPage(L), pages = [];
  for (let i = 0; i < slots.length; i += n) pages.push(slots.slice(i, i + n));
  return pages;
}
